import React from 'react';
import DataMap from '../components/features/DataMap';

const Map = () => {
  return (
    <div>

        <section className="bg-image pt-25 pb-25">
            <div className="container">
                <h2 className="Banner-Title">Map</h2>
            </div>
        </section>

        <DataMap/>
    </div>
  )
}

export default Map